import React from 'react'
import { Grid } from '@material-ui/core'
import {
  Traslates,
  InputHLPure,
  PanelBarGLPure,
  CheckBoxHLPure,
  DataPickerHLPure,
  GridSelectionHLPure
} from '../../pures'

const INFO_TYPE_DOCUMENT = Number(process.env.REACT_APP_INFO_TYPE_DOCUMENT)
const INFO_TYPE_EXP = Number(process.env.REACT_APP_INFO_TYPE_EXP)

const HeaderColumns = (props) => {
  return (
    <span className={(props.title === props.t('digitalVaultUploadView.grid.title.1') || props.title === props.t('digitalVaultUploadView.modal.entities.grid.title.1')) ? 'grid-header-one' : 'grid-headers'}>{props.title}</span>
  )
}

const CellColumnOne = (props) => {
  const { dataItem } = props

  return (
    <td className={`digitalVaultUploadView-col1 ${dataItem.selected ? 'selected' : ''}`}>
      <div>
        <p className='grid-cell-titles-margin-left grid-cell-title'>{dataItem.name}</p>
      </div>
    </td>
  )
}

/**
 * @function DocumentDataPanel
 * @description Panel de datos del documento/expediente con configuración de tipo, nombre, archivos, descripción, fechas, tags
 * @param {{
 *   t: function,
 *   uploadData: {infoType: number, name: string, uploadedFiles: Array, description: string},
 *   onDataChange: function,
 *   documentId: number|null,
 *   invalidFields: Array<string>,
 *   fileShown: {name: string, fileBase64: string, fileType: string, type: string, file: boolean},
 *   setFileType: function,
 *   handleWathchExp: function,
 *   deleteFile: function,
 *   setFileSelected: function,
 *   disableElements: boolean,
 *   inputTag: string,
 *   handleInputTag: function,
 *   onBlurInputTag: function,
 *   onEnterTag: function,
 *   tags: Array,
 *   handleDeleteChipTag: function,
 *   dateStart: Date|null,
 *   dateEnd: Date|null,
 *   onChangeDatepicker: function,
 *   onChangeDatepickerDateEnd: function,
 *   formatCeleb: string,
 *   formatVen: string,
 *   limitDateDue: Date|null,
 *   confidential: boolean,
 *   handleChangeCheckConfidential: function,
 *   notify: boolean,
 *   handleChangeCheckNotify: function
 * }} props
 * @returns {JSX.Element}
 */
const DocumentDataPanel = (props) => {
  const {
    t,
    dateEnd,
    formatVen,
    fileShown,
    dateStart,
    documentId,
    uploadData,
    deleteFile,
    formatCeleb,
    setFileType,
    confidential,
    onDataChange,
    limitDateDue,
    invalidFields,
    setFileSelected,
    handleWathchExp,
    disableElements,
    onChangeDatepicker,
    onChangeDatepickerDateEnd,
    handleChangeCheckConfidential
  } = props

  const AllHeadersColumns = (props) => <HeaderColumns {...props} t={t} />

  const widthColumnOne = '150px'
  const widthColumnFive = '50px'

  let skip = 0
  if (fileShown.file) {
    const i = uploadData.uploadedFiles.findIndex(f => f.name === fileShown.name && f.fileBase64 === fileShown.fileBase64)
    if (i !== -1) skip = Math.floor(i / 5) * 5
  }

  return (
    <Grid>
      <PanelBarGLPure
        expandedPanel={true}
        titlePanel={`${uploadData.infoType === INFO_TYPE_DOCUMENT ? (t('digitalVaultUploadView.modal.document.data.title')) : (t('digitalVaultUploadView.modal.file.data.title'))}`}
        id='documentPanelBarVariables'
      >
        <span style={{ fontFamily: "QuickSand", fontWeight: 600, fontSize: 14, color: "#427FBA", opacity: 1 }}>{t('digitalVaultUploadView.storage.type')}</span>
        <div className="documentPanelBarBasicData-checkBox-group">
          <label className="checkbox-item">
            <CheckBoxHLPure
              checkedState={uploadData.infoType === INFO_TYPE_DOCUMENT}
              onChangeHandler={() => onDataChange({ target: { value: INFO_TYPE_DOCUMENT } }, 'infoType')}
              disabled={!!documentId}
            />
            <span>{t('digitalVaultUploadView.data.document')}</span>
          </label>

          <label className="checkbox-item">
            <CheckBoxHLPure
              checkedState={uploadData.infoType === INFO_TYPE_EXP}
              onChangeHandler={() => onDataChange({ target: { value: INFO_TYPE_EXP } }, 'infoType')}
              disabled={!!documentId}
            />
            <span>{t('digitalVaultUploadView.data.exp')}</span>
          </label>
          <InputHLPure
            labelInput={uploadData.infoType === INFO_TYPE_DOCUMENT ? t('digitalVaultUploadView.document.name') : t('digitalVaultUploadView.document.exp')}
            inputActive
            valueInput={uploadData.name}
            handleChangeInput={(e) => onDataChange(e, 'name')}
            typeInput={'text'}
            characterLimit={128}
            errorInput={invalidFields.includes('name')}
            errorInputText={t('digitalVaultUploadView.errors.name')}
            required
          />

          {
            <Grid item xs={12} className='digitalVaultUploadView-grid'>
              <GridSelectionHLPure
                skip={skip}
                take={5}
                pageable
                dataGrid={uploadData.uploadedFiles.map(f => f.name === fileShown.name && f.fileBase64 === fileShown.fileBase64 ? { ...f, selected: true } : { ...f })}
                noRecordsMessage={t('digitalVaultUploadView.errors.no.records')}

                titleRow1={uploadData.infoType === INFO_TYPE_DOCUMENT ? t('digitalVaultUploadView.grid.title.1.document') : t('digitalVaultUploadView.grid.title.1')}
                cellColumnOne={CellColumnOne}
                headerColumnOne={AllHeadersColumns}
                widthColumnOne={widthColumnOne}
                minResizableWidth1={'auto'}

                columnFive
                columnFiveStyleClass={'digitalVaultUploadView-cellActions'}
                titleRow5={t('digitalVaultUploadView.grid.title.5')}
                iconOneActive
                labelOneActions={t('digitalVaultUploadView.grid.btns.view.document')}
                activeDialog1
                btnOpenDialog1={(!documentId) ? (dataItem) => {
                  setFileType(dataItem.fileType)
                  setFileSelected(dataItem)
                } :
                  (dataItem) => handleWathchExp(dataItem)
                }
                iconTrashActive={(!documentId) ? true : false}
                labelTrashActions={t('digitalVaultUploadView.grid.btns.delete')}
                activeDialogTrash={(!documentId) ? true : false}
                btnOpenDialogTrash={(dataItem) => deleteFile(dataItem)}
                tooltipTrashIcon={t('button.delete')}
                widthColumnFive={widthColumnFive}
                minResizableWidth5={widthColumnFive}

                onSelectedItem={setFileSelected}
                setNameComponentUser={() => { }}
                setShowDetails={() => { }}
              />
            </Grid>
          }

          <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData' style={{ width: '100%' }}>
            <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-dates-checkbox-row' style={{ display: 'flex', gap: '2rem', marginTop: "15px" }}>
              <div className='date-block' style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: "10px" }}>
                <Traslates>
                  <DataPickerHLPure
                    labelDataPicker={t('digitalVaultUploadView.start.date')}
                    valueDate={dateStart}
                    handleChangeDate={(e) => onChangeDatepicker(e)}
                    formatPicker={formatCeleb}
                    disabled={disableElements}
                  />
                </Traslates>
                <label style={{ display: 'flex', alignItems: 'center', marginTop: '0.5rem' }}>
                  <CheckBoxHLPure
                    checkedState={confidential}
                    onChangeHandler={(e) => handleChangeCheckConfidential(e)}
                    disabled={disableElements}
                  />
                  <span style={{ marginLeft: '0.5rem' }}>{t('documentPanelBarBasicData.confidential')}</span>
                </label>
              </div>
              <div className='date-block' style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: "10px" }}>
                <Traslates>
                  <Traslates>
                    <DataPickerHLPure
                      labelDataPicker={t('digitalVaultFollowUpDocument.date.due')}
                      valueDate={dateEnd instanceof Date ? dateEnd : null}

                      handleChangeDate={(e) => onChangeDatepickerDateEnd(e)}
                      formatPicker={formatVen}
                      disabled={disableElements}
                      limitDate={limitDateDue instanceof Date ? limitDateDue : undefined}
                    />
                  </Traslates>
                </Traslates>
              </div>
            </div>
          </div>
        </div>
      </PanelBarGLPure>
    </Grid>
  )
}

export default DocumentDataPanel
